import { IsString, ValidateNested, IsDefined } from 'class-validator';
import { Type } from 'class-transformer';
import { HeadingLevelDto } from './HeadingLevelDto';

export class HeadingTypographyDto {
  @IsDefined()
  @IsString()
  fontFamily!: string;

  @IsDefined()
  @ValidateNested()
  @Type(() => HeadingLevelDto)
  h1!: HeadingLevelDto;

  @IsDefined()
  @ValidateNested()
  @Type(() => HeadingLevelDto)
  h2!: HeadingLevelDto;

  @IsDefined()
  @ValidateNested()
  @Type(() => HeadingLevelDto)
  h3!: HeadingLevelDto;

  @IsDefined()
  @ValidateNested()
  @Type(() => HeadingLevelDto)
  h4!: HeadingLevelDto;

  @IsDefined()
  @ValidateNested()
  @Type(() => HeadingLevelDto)
  h5!: HeadingLevelDto;

  @IsDefined()
  @ValidateNested()
  @Type(() => HeadingLevelDto)
  h6!: HeadingLevelDto;
}
